<template>
  <ProsCarousel
    v-if="productIds.length > 0"
    class="pros-rvi"
    :config-data="getConfigData"
    @removeProductsEvent="removeLocalStorageProduct"
    @rviEditEvent="rviEdit"
    @rviDoneEvent="rviDone"
    @dataLoadStatusEvent="(e) => $emit('dataLoadStatusEvent', e)"
  />
</template>

<script>
import isBcom from '@common-vue/product-thumbnail/src/utils/isBcom';
import ProsCarousel from '../ProsCarousel/ProsCarousel';
import { getRecentlyViewedItems } from '../../utils/utils';
import prosZones from '../../utils/prosZones';
import constants from '../../utils/constants';
import {
  fireRVIEditClickTag,
  fireRVIEditDoneClickTag,
  fireRVIEditRemoveClickTag,
} from '../../analytics/analyticsEvent';

const { SMALL, MEDIUM, LARGE } = constants.BREAK_POINT_TYPE;
const { BCOM, MCOM } = constants.ENTRY_POINT;

const numberOfItems = {
  [BCOM]: {
    [SMALL]: 2.5,
    [MEDIUM]: 5.5,
    [LARGE]: 6,
  },
  [MCOM]: {
    [SMALL]: 2.5,
    [MEDIUM]: 5.14,
    [LARGE]: 5.25,
  },
};

const impressionData = {
  zone_type: 'rvi',
  zone_title: 'recently viewed items',
};

export default {
  name: 'RviCarousel',
  components: { ProsCarousel },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['dataLoadStatusEvent'],
  setup() {
    const entryPoint = process.env.ENTRY_POINT;
    return { entryPoint };
  },
  data() {
    const productIds = [prosZones.PDP_PAGE.rvi_pdp_zone, prosZones.PDP_PAGE.RVI_PDP].includes(this.configData.recommendationConfig?.zone)
      ? this.configData.productIds.filter((id) => id !== this.configData.recommendationConfig.productId) || []
      : this.configData.productIds || [];

    return {
      numberOfItems:
        this.configData.numberOfItems || numberOfItems[this.entryPoint],
      recommendationData: this.configData.recommendationData || {},
      productIds,
    };
  },
  computed: {
    getConfigData() {
      return {
        ...this.configData,
        editProducts: !isBcom,
        impressionData,
        linkName: !isBcom && constants.LINK_NAME.EDIT,
        numberOfItems: this.numberOfItems,
        recommendationData: this.recommendationData,
        title: `Recently viewed ${this.productIds?.length === 1 ? 'item' : 'items'}`,
        useWishList: false,
        wrapProductName: true,
        productIds: this.productIds,
      };
    },
  },
  methods: {
    removeLocalStorageProduct() {
      // need to add event
    },
    rviEdit() {
      fireRVIEditClickTag(this.configData?.zone, this.title);
    },
    rviDone(removeIds) {
      const removeIdsMap = Object.values(removeIds).map((a) => a.toString());
      const recentlyViewed = getRecentlyViewedItems();
      const withoutProductId = recentlyViewed.filter(
        (i) => !(removeIdsMap.includes(i)),
      );
      if (recentlyViewed === withoutProductId) {
        fireRVIEditDoneClickTag(this.configData?.zone, this.title);
      }

      localStorage.setItem(
        constants.RECENTLY_VIEWED_ITEMS,
        withoutProductId.join(','),
      );
      this.productIds = withoutProductId;
      removeIdsMap.forEach((id) => fireRVIEditRemoveClickTag(id, this.configData?.zone, this.title));
    },
  },
};
</script>

<style lang="scss">
.pros-collection .pros-rvi {
  .carousel-container {
    .title-container {
      padding-right: 0;
    }
  }
}
</style>

<style lang="scss" brand="mcom">
.pros-collection {
  &.pros-collection-SB_ZONE_EMPTY, &.pros-collection-rvi_bag_zone, &.pros-collection-SB_ZONE_A {
    .header-container {
      h3, h4 {
        font-size: rem-calc(24);
      }
    }
  }
}
</style>
